import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
// import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { WithdrawalcoinlistPage } from '../withdrawalcoinlist/withdrawalcoinlist';
import { WithdrawalpointlistPage } from '../withdrawalpointlist/withdrawalpointlist';

/**
 * Generated class for the WithdrawalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-withdrawal',
    templateUrl: 'withdrawal.html',
})
export class WithdrawalPage {

    list: string = 'completed';
    segment: string;

	loginId: string;
	email: string;
    api_key: string;
    version: string;
	wallet_address: string;
    coin: string = '';
    office_address: string;
	address: string;
	rate: any = [];

	completed_list: any = [];
	pending_list: any = [];
    // params: any[] = [];
    // count: number = 0;
    // max_length: number = 0;
    
	coin_unit: string;
	token_unit: string;
	unit: string;
	cash_unit: string;
	cash_room_unit: string;
	bonus_room_unit: string;
    
    balance: any = [];
    balance_usdt: string;

	imagePath: string;
	qrData = null;
  	createdCode = null;
	scannedCode = null;

	texts: any = [];
    language : string;

    isButton : boolean = true;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
        // private clipboard: Clipboard,
        private http: HttpService,
		public app: App
	) {
        let segment = navParams.get("segment");

        if (segment == 'pending') {
            this.list = segment;
        } else {
            this.list = 'completed';
        }
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "withdrawalcoinlist");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.unit = localStorage.getItem("unit");
		this.cash_unit = localStorage.getItem("cash_unit");
		this.token_unit = localStorage.getItem("token_unit");
		this.cash_room_unit = localStorage.getItem("cash_room_unit");
		this.bonus_room_unit = localStorage.getItem("bonus_room_unit");

        this._get_texts();

		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).withdrawal;
	}

	_init() {		
		this.completed_list = [];
		this.pending_list = [];
		
        let url = "withdraw/base";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
			    // 	this.office_address = res.address;
                // this.rate = res.rate;
                this.balance = res.balance;

			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: err.message,
				buttons: ['OK']
			});
			alert.present();
		});
	}	

    _withdrawal(event) {
        if (event == 'cash') {
            this.navCtrl.push(WithdrawalpointlistPage, {from : 'list'});
        }

        if (event == 'coin') {
            this.navCtrl.push(WithdrawalcoinlistPage, {target_coin : event});
        }

        if (event == 'token') {
            this.navCtrl.push(WithdrawalcoinlistPage, {target_coin : event});
        }

        if (event == 'ready') {
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_ready,
                buttons: ['OK']
            });
            alert.present();
        }

    }
}



// WEBPACK FOOTER //
// ./src/pages/withdrawal/withdrawal.ts